import { render, staticRenderFns } from "./FollowPeriod.vue?vue&type=template&id=6e35365e&scoped=true"
import script from "./FollowPeriod.vue?vue&type=script&lang=js"
export * from "./FollowPeriod.vue?vue&type=script&lang=js"
import style0 from "./FollowPeriod.vue?vue&type=style&index=0&id=6e35365e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e35365e",
  null
  
)

export default component.exports